/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, coloredScrollBar, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : AUTO FILL TEXT : STYLES --------------- ++++++++++ */
export default theme => ({
    autotextfill: {
        width: pxToEm(305),
        height: 'auto',
        maxHeight: pxToEm(428),
        display: 'flex',
        flexDirection: 'column',
        padding: `${pxToEm(10)} 0`,
        backgroundColor: theme.color.light.light.swatch,
        '& .name-items': {
            overflow: 'scroll',
            overflowX: 'hidden',
            extend: coloredScrollBar(theme.color.primary.medium.swatch),
            boxShadow: theme.boxShadow.small,
            '&.active-true': {
                transition: 'all .15s'
            },
            '&.active-false': {
                height: pxToEm(0),
                padding: 0,
                overflow: 'hidden',
                pointerEvents: 'none',
                transition: 'all .15s',
                opacity: 0
            },
        }
    }
});
